export const PLAYER = 1 << 0;
export const GROUND = 1 << 1;
export const PROJECTILES = 1 << 2;
export const COINS = 1 << 3;
export const ENEMIES = 1 << 4;
export const PLAYER_DAMAGE = 1 << 5;
export const GRAPHICS = 1 << 6;

export const TABLE = 1 << 7;
export const TABLE_BACK = 1 << 8;
export const TABLE_FRONT = 1 << 9;

export const TABLE_ITEM_BACK = 1 << 10;
export const TABLE_ITEM_FRONT = 1 << 11;

export const PLAYER_INTERACTIONS = GROUND | COINS;
export const GROUND_INTERACTIONS = PLAYER | PROJECTILES | ENEMIES | TABLE | TABLE_ITEM_BACK | TABLE_ITEM_FRONT;
export const PROJECTILES_INTERACTIONS = GROUND | ENEMIES;
export const COINS_INTERACTIONS = PLAYER;
export const ENEMIES_INTERACTIONS = PLAYER_DAMAGE | PROJECTILES | GROUND;
export const PLAYER_DAMAGE_INTERACTIONS = ENEMIES;
export const GRAPHICS_INTERACTIONS = 0;

export const TABLE_INTERACTIONS = GROUND | TABLE_ITEM_FRONT | TABLE_ITEM_BACK;

export const TABLE_ITEM_BACK_INTERACTIONS = GROUND | TABLE | TABLE_ITEM_BACK;
export const TABLE_ITEM_FRONT_INTERACTIONS = GROUND | TABLE | TABLE_ITEM_FRONT;

export function createCollisionFilter(aType, aMask) {
    return {
        category: aType,
        mask: aMask
    };
}